export function useUpdateBuildInfo() {
  // do nothing for web
}
